import { Fragment } from "react";
import { Col, Row } from "react-bootstrap";
import SearchBox from "components/common/SearchBox";
import NoDataFound from "components/common/NoDataFound";
import CustomLoader from "components/common/CustomLoader";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DealDetailsTimeline from "components/timelines/DealDetailsTimeline";

const DealDetailsActivity = ({
  activities,
  allActivities,
  handleSearchInputChange,
  isLoading,
}: any) => {
  return (
    <Fragment>
      {allActivities?.length > 0 ? (
        <>
          <Row className="align-items-center g-3 justify-content-between mb-4">
            <Col sm="auto">
              <SearchBox
                placeholder="Search Deal Activity"
                onChange={handleSearchInputChange}
                prepend={<FontAwesomeIcon icon={faSearch} className="text-muted" />}
              />
            </Col>
          </Row>
          <DealDetailsTimeline
            activities={activities}
            allActivities={allActivities}
          />
        </>
      ) : isLoading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <CustomLoader />
        </div>
      ) : (
        <NoDataFound type="Activities" customClass="mt-lg-10" />
      )}
    </Fragment>
  );
};

export default DealDetailsActivity;